import { COMMUNICATION_PREFERENCES_ACTION_TYPES } from '@constants/actionTypes/dashboardActionTypes';

// Types

import { Address, CommunicationPreferences, ReduxAction } from '@components/ssap/SsapTypes';

// TODO: come up with typing action default value
interface CommunicationPreferencesActionType extends Omit<ReduxAction, 'type' | 'preferences'> {
    type: string,
    preferences: {},
    languages: {}
}

interface CommunicationPreferencesState { }

export const INITIAL_STATE: CommunicationPreferences | { } = { };

export default (
    state = INITIAL_STATE,
    action: CommunicationPreferencesActionType = { type: '', preferences: {}, languages: {} }
): CommunicationPreferencesState => {
    switch(action.type) {
        case COMMUNICATION_PREFERENCES_ACTION_TYPES.SET_COMMUNICATION_PREFERENCES:
            return {
                ...state,
                ...action.preferences
            };
        case COMMUNICATION_PREFERENCES_ACTION_TYPES.SET_LANGUAGES:
            return {
                ...state,
                languages: action.languages
            };
        case COMMUNICATION_PREFERENCES_ACTION_TYPES.CLEAR_DASHBOARD_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};

// selectors

export const selectMailingAddressFromComPref = (state: CommunicationPreferences): Address => state.mailingAddress;
export const selectIfCommunicationPreferencesLoaded = (state: CommunicationPreferences): boolean => {
    return (state && Object.keys(state).some(key => key !== 'languages')); //true only when preference fields exist — not languages alone
};
export const selectIfLanguagesLoaded = (state: CommunicationPreferences): boolean => {
    return (state && Object.keys(state.languages ?? {}).length > 0);
};